import getBrowserLocation from '../utils/browserLocation';

window.cohesion('preamp:done', () => {
  const header = document.querySelector('.bootcamp-header');
  const link = header.querySelector('.js-header-cta');

  if (!(header || link)) {
    return;
  }

  const elementPayload = {
    location: 'nav-bar',
    position: '',
    elementType: 'banner-cta',
    text: 'FIND MY BOOTCAMP',
    name: 'voyager_entry',
    htmlId: 'bootcamp_nv_bar_cta',
  };

  const isElementInViewport = (el) => {
    const rect = el.getBoundingClientRect();
    return (
      rect.bottom > 0 &&
      rect.right > 0 &&
      rect.left < (window.innerWidth || document.documentElement.clientWidth) &&
      rect.top <
        (window.innerHeight - 200 ||
          document.documentElement.clientHeight - 200)
    );
  };
  let headerViewed = false;

  if (isElementInViewport(header) && !headerViewed) {
    window.tagular('beam', 'ElementViewed', {
      '@type': 'redventures.usertracking.v3.ElementViewed',
      webElement: elementPayload,
    });
    headerViewed = true;
  }
  if (!headerViewed) {
    document.addEventListener('scroll', () => {
      if (isElementInViewport(header) && !headerViewed) {
        window.tagular('beam', 'ElementViewed', {
          '@type': 'redventures.usertracking.v3.ElementViewed',
          webElement: elementPayload,
        });
        headerViewed = true;
      }
    });
  }

  getBrowserLocation().then((location) => {
    if (location !== 'us') {
      link.classList.add('hidden');
    }
  });
});
